// Determine what set of stops to edit
export enum UnmappedStopsEditMode {
  UnmappedDeliveries = 'Unmapped Deliveries',
  UnmappedPickups = 'Unmapped Pickups',
  UnassignedDelivery = 'Unassigned Delivery',
  UnassignedPickup = 'Unassigned Pickup',
  AssignedStop = 'Assigned Stop',
}
